import { MutationUpdaterFn, Reference } from "@apollo/client";
import { Modifier } from "@apollo/client/cache/core/types/common";

import { CreateCommentMutation } from "@/generated/generated-hooks";

export const updateAfterComment: MutationUpdaterFn<CreateCommentMutation> = (
  cache,
  { data: { createComment } },
) => {
  /* update number of replies */
  const isReplyingToComment = !!createComment.parentCommentId;

  const updateReplyingToComment = () => {
    cache.modify({
      id: cache.identify({
        __typename: "Comment",
        _id: createComment.parentCommentId,
      }),
      fields: {
        numberOfReplies(existingNumberOfReplies) {
          return existingNumberOfReplies + 1;
        },
      },
    });
    const key = `commentPage:{"input":{"postId":"${createComment.postId}","parentCommentId":"${createComment.parentCommentId}"}}`;

    const modifier: Modifier<{ items: Reference[] }> = (
      existing,
      { toReference },
    ) => {
      const dataRef = toReference({
        _id: createComment._id,
        __typename: "Comment",
      });

      const updatedItems = [...existing.items, dataRef];

      return { ...existing, items: updatedItems };
    };

    cache.modify({
      fields: {
        [key]: modifier,
      },
    });
  };

  const updateCommentingToPost = () => {
    cache.modify({
      id: cache.identify({ __typename: "Post", _id: createComment.postId }),
      fields: {
        commentCount(existingCommentCount) {
          return existingCommentCount + 1;
        },
      },
    });
    const key = `commentPage:{"input":{"postId":"${createComment.postId}"}}`;

    const modifier: Modifier<{ items: Reference[] }> = (
      existing,
      { toReference },
    ) => {
      const dataRef = toReference({
        _id: createComment._id,
        __typename: "Comment",
      });

      const updatedItems = [dataRef, ...existing.items];

      return { ...existing, items: updatedItems };
    };

    cache.modify({
      fields: {
        [key]: modifier,
      },
    });
  };

  if (isReplyingToComment) {
    updateReplyingToComment();
  } else {
    updateCommentingToPost();
  }
};
